export default __webpack_public_path__ + "static/media/Frame-1.8d58d4d8.png";